import React, { useState, useEffect } from "react";
import { Icon, useToast } from "@chakra-ui/react";
import { BiLinkExternal } from "react-icons/bi";
import { MdCancel } from "react-icons/md";
import { BsCheckCircle } from "react-icons/bs";
import ResponsiveRow from "../../Common/Table/ResponsiveRow";
import TdType from "../../Common/Table/TdType";
import moment from "moment";
import { currencyFormatter } from "../../../Utils/formatUtils";

const HistoryItem = ({
  history,
  setShowNewPayment,
  initialAction = "row",
  key,
  addHistory,
}) => {
  const [action, setAction] = useState(initialAction);
  const [newHistory, setNewHistory] = useState(history);
  const toast = useToast();
  moment.locale();

  useEffect(() => {
    if (!history.payday) {
      history.payday = new Date().toLocaleString("af-ZA", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    }
    setNewHistory(history);
  }, [action]);

  const validateForm = async () => {
    if (!newHistory.payday || !newHistory.total) {
      toast({
        title: "Se ha producido un error.",
        description: "Verifique todos los campos",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    } else {
      let history = { ...newHistory };
      switch (action) {
        case "new":
          await addHistory({
            payedAt: history.payday,
            comments: history.comments,
            payment: history.total,
          });
          break;
      }
      setShowNewPayment(false);
      setAction("row");
    }
  };

  const handleCancel = () => {
    setAction("row");
  };

  const handleChange = (val) => {
    setNewHistory({ ...newHistory, [val.target.id]: val.target.value });
  };

  const handleEdit = () => {
    setAction("edit");
  };

  const handleSubmit = () => {
    validateForm();
  };

  const rowDisplay = () => {
    let rowData = [];
    // eslint-disable-next-line default-case
    switch (action) {
      case "edit":
        rowData = [
          {
            item: (
              <TdType
                inputType="date"
                id="payday"
                value={newHistory.payday}
                onChange={handleChange}
              />
            ),
          },
          {
            item: (
              <TdType
                inputType="input"
                id="comments"
                value={newHistory.comments}
                onChange={handleChange}
              />
            ),
          },
          {
            item: (
              <TdType
                inputType="input"
                id="total"
                value={currencyFormatter(newHistory.total)}
                onChange={handleChange}
              />
            ),
          },
          {
            tdStyle: {
              textAlign: "center",
              fontSize: "1.5em",
              width: "15%",
            },
            item: (
              <>
                <Icon
                  _hover={{ cursor: "pointer" }}
                  mx="2"
                  as={BsCheckCircle}
                  onClick={() => handleSubmit()}
                  color="green"
                  title={"Aceptar"}
                ></Icon>
                <Icon
                  _hover={{ cursor: "pointer" }}
                  mx="2"
                  as={MdCancel}
                  color="red"
                  title={"Cancelar"}
                  onClick={() => handleCancel()}
                ></Icon>
              </>
            ),
          },
        ];
        return <ResponsiveRow key={key} cells={rowData}></ResponsiveRow>;

      case "new":
        rowData = [
          {
            item: (
              <TdType
                inputType="date"
                id="payday"
                value={newHistory.payday}
                onChange={handleChange}
              />
            ),
          },
          {
            item: (
              <TdType
                inputType="input"
                id="comments"
                value={newHistory.comments}
                onChange={handleChange}
              />
            ),
          },
          {
            item: (
              <TdType
                inputType="input"
                id="total"
                value={newHistory.total}
                onChange={handleChange}
              />
            ),
          },
          {
            tdStyle: {
              textAlign: "center",
              fontSize: "1.5em",
              width: "15%",
            },
            item: (
              <>
                <Icon
                  _hover={{ cursor: "pointer" }}
                  mx="2"
                  as={BsCheckCircle}
                  color="green"
                  onClick={() => handleSubmit()}
                  title={"Aceptar"}
                ></Icon>
                <Icon
                  _hover={{ cursor: "pointer" }}
                  mx="2"
                  as={MdCancel}
                  color="red"
                  title={"Cancelar"}
                  onClick={() => setShowNewPayment(false)}
                ></Icon>
              </>
            ),
          },
        ];
        return <ResponsiveRow key={key} cells={rowData}></ResponsiveRow>;

      case "row":
        rowData = [
          {
            item: <TdType text={moment(history.payday).format("DD-MM-YYYY")} />,
          },
          {
            item: (
              <TdType
                customStyle={{
                  textAlign: "center",
                }}
                text={history.comments ?? "-"}
              />
            ),
          },
          {
            item: (
              <TdType
                customStyle={{
                  textAlign: "right",
                  color: history.total < 0 && "red",
                }}
                text={currencyFormatter(history.total)}
              />
            ),
          },

          {
            tdStyle: {
              textAlign: "center",
              fontSize: "1.3em",
            },
            item: history.purchaseId ? (
              <Icon
                _hover={{ cursor: "pointer" }}
                mx="2"
                as={BiLinkExternal}
                onClick={() => window.open(`/compras/${history.purchaseId}`)}
                title={"Editar pago"}
              ></Icon>
            ) : (
              "-"
            ),
          },
        ];
        return <ResponsiveRow key={key} cells={rowData}></ResponsiveRow>;
    }
  };

  return rowDisplay();
};

export default HistoryItem;
